// api/safeApiCall.ts
import { AxiosError, isAxiosError } from "axios";
import { ApiResult } from "./APIResult";

export const apiRequest = async <T,>(
  fn: () => Promise<T>
): Promise<ApiResult<T>> => {
  try {
    const data = await fn();
    return { success: true, data };
  } catch (error) {
    let message = "Something went wrong";
    let status: number | undefined;

    if (isAxiosError(error)) {
      message = error.response?.data?.message || error.message;
      status = error.response?.status;
    }

    console.error("API Error:", message);
    return { success: false, error: message, status };
  }
};
